import request from './request';

export function login(payload) {
  return request.post('/auth/merchant/login', payload);
}

